module.exports = __webpack_public_path__ + "7caab0c9e1657b1632313543e560a8be.png";